import React from 'react';

// mui
import { Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';

// components
import {
  EndorsementDateForPrime100,
  EndorsementDateForPrime250,
} from './EndorsementDate';
import { ProductTypes } from '../../../../types';
import { toUniversalUtcDate } from '../../../../utils/date.utils';

const SubHeader = ({
  readOnly = false,
  policyDetails,
  originalPolicyDetails,
  updateDate,
  currentSelectedDate,
}: any) => {
  const classes = useStyles();

  return (
    <Grid container justifyContent="space-between" className={classes.common}>
      <Grid item md={6}>
        SUMMARY
      </Grid>
      <Grid item container md={6} justifyContent="flex-end">
        <Grid item style={{ textAlign: 'right' }}>
          Endorsement Start Date:{' '}
        </Grid>
        <Grid item style={{ textAlign: 'left' }}>
          {policyDetails.product === ProductTypes.p100 && !readOnly && (
            <EndorsementDateForPrime100
              updateDate={updateDate}
              currentDate={currentSelectedDate}
              policyDetails={policyDetails}
            />
          )}

          {policyDetails.product === ProductTypes.p250 && !readOnly && (
            <EndorsementDateForPrime250
              updateDate={updateDate}
              currentDate={currentSelectedDate}
              latestPolicyDetails={policyDetails}
              originalPolicyDetails={originalPolicyDetails}
            />
          )}

          {readOnly && (
            <span className={classes.date}>
              {toUniversalUtcDate(currentSelectedDate)}
            </span>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};

const useStyles = makeStyles(({ palette, config }) => ({
  common: {
    color: palette.primary.contrastText,
    fontWeight: config.weights.bold,
    lineHeight: 1.4,
    fontSize: config.textSizes.paragon,
    padding: '0 2.16rem 1.33rem',
  },
  date: {
    paddingLeft: '0.625rem',
    color: config.colors.cowbellBlue,
    fontSize: config.textSizes.paragon,
    fontWeight: config.weights.bold,
  },
}));

export default SubHeader;
